import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './User_Role_Assignment.css';

const User_Role_Assignment = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"USER_ROLE_ASSIGNMENT",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	USER_ROLE_ASSIGNMENT:-1
  });


  const [USER_ROLE_ASSIGNMENT, setUSER_ROLE_ASSIGNMENT] = React.useState(null);
  const [USER_ROLE_ASSIGNMENT_D, setUSER_ROLE_ASSIGNMENT_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('User Role Assignment');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/User_Role_Assignment',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewUSER_ROLE_ASSIGNMENT(clientInfo,"OpenNew");

		navigate('/User_Role_Assignment',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/User_Role_Assignment_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutUSER_ROLE_ASSIGNMENT(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostUSER_ROLE_ASSIGNMENT(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewUSER_ROLE_ASSIGNMENT(clientInfo,"OpenNew");
		}
		navigate('/User_Role_Assignment',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/User_Role_Assignment_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/User_Role_Assignment_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/User_Role_Assignment_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
		if(Temp_Data2.status!="New"){
			handleDeleteUSER_ROLE_ASSIGNMENT(Temp_Data2);
			navigate('/User_Role_Assignment#New',{replace:true});
		} 
		else 
			navigate('/User_Role_Assignment',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/User_Role_Assignment',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/User_Role_Assignment',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/User_Role_Assignment',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/User_Role_Assignment',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!USER_ROLE_ASSIGNMENT) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {
    if ($('#Table2').length > 0) window.DataTableScript('#Table2');

    initRef.current.dataTableHandled = true;
  }  

  }, [USER_ROLE_ASSIGNMENT]) ;


  
  
  var Ids = [];
  for(var Ele in USER_ROLE_ASSIGNMENT){
	  for(var Sec in USER_ROLE_ASSIGNMENT[Ele]){
		if(Sec == "id")
			Ids.push(USER_ROLE_ASSIGNMENT[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(USER_ROLE_ASSIGNMENT[Ele]["status"]);
		else if(Array.isArray(USER_ROLE_ASSIGNMENT[Ele][Sec]))
			  for(var Row in USER_ROLE_ASSIGNMENT[Ele][Sec])  // Convert to USER_ROLE_ASSIGNMENT[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in USER_ROLE_ASSIGNMENT[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["USER_ROLE_ASSIGNMENT"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewUSER_ROLE_ASSIGNMENT(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/USER_ROLE_ASSIGNMENT`).then((response1) => {
		if(!USER_ROLE_ASSIGNMENT) 
			setUSER_ROLE_ASSIGNMENT(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/USER_ROLE_ASSIGNMENT_D`).then((response2) => {
			setUSER_ROLE_ASSIGNMENT_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddUSER_ROLE_ASSIGNMENT_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewUSER_ROLE_ASSIGNMENT = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/USER_ROLE_ASSIGNMENT/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setUSER_ROLE_ASSIGNMENT(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataUSER_ROLE_ASSIGNMENT = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/USER_ROLE_ASSIGNMENT/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutUSER_ROLE_ASSIGNMENT = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/USER_ROLE_ASSIGNMENT/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostUSER_ROLE_ASSIGNMENT = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/USER_ROLE_ASSIGNMENT', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteUSER_ROLE_ASSIGNMENT = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/USER_ROLE_ASSIGNMENT', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_0"]=value;
	//handleAddUSER_ROLE_ASSIGNMENT(Temp_Data,App_Data['USER_ROLE_ASSIGNMENT']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_0",value,Temp_Data);
 	//handleLastDataUSER_ROLE_ASSIGNMENT(Temp_Data);
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_1"]=value;
	//handleAddUSER_ROLE_ASSIGNMENT(Temp_Data,App_Data['USER_ROLE_ASSIGNMENT']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_1",value,Temp_Data);
 	//handleLastDataUSER_ROLE_ASSIGNMENT(Temp_Data);
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["1"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_2"]=value;
	//handleAddUSER_ROLE_ASSIGNMENT(Temp_Data,App_Data['USER_ROLE_ASSIGNMENT']);
	Form_Data_onChange("1","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_2",value,Temp_Data);
 	//handleLastDataUSER_ROLE_ASSIGNMENT(Temp_Data);
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_0"]=value;
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_0",value,Temp_Data);
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
  }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_1"]=value;
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_1",value,Temp_Data);
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
  }; 
  
  
      
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_2_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["3"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_2"]=value ? true : false; // optionally just use boolean
	//handleAddUSER_ROLE_ASSIGNMENT(Temp_Data,App_Data['USER_ROLE_ASSIGNMENT']);
	Form_Data_onChange("3","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_2",value,Temp_Data);
 	//handleLastDataUSER_ROLE_ASSIGNMENT(Temp_Data);
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
 }; 
  



const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_0",value,Temp_Data);
 	//handleLastDataUSER_ROLE_ASSIGNMENT(Temp_Data);
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
	//handleAddUSER_ROLE_ASSIGNMENT(Temp_Data,App_Data['USER_ROLE_ASSIGNMENT']);
  }; 
  

    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_1"]=value;
	//handleAddUSER_ROLE_ASSIGNMENT(Temp_Data,App_Data['USER_ROLE_ASSIGNMENT']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_1",value,Temp_Data);
 	//handleLastDataUSER_ROLE_ASSIGNMENT(Temp_Data);
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_2"]=value;
	//handleAddUSER_ROLE_ASSIGNMENT(Temp_Data,App_Data['USER_ROLE_ASSIGNMENT']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_2",value,Temp_Data);
 	//handleLastDataUSER_ROLE_ASSIGNMENT(Temp_Data);
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_3"]=value;
	//handleAddUSER_ROLE_ASSIGNMENT(Temp_Data,App_Data['USER_ROLE_ASSIGNMENT']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_3",value,Temp_Data);
 	//handleLastDataUSER_ROLE_ASSIGNMENT(Temp_Data);
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["9"]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_4"]=value;
	//handleAddUSER_ROLE_ASSIGNMENT(Temp_Data,App_Data['USER_ROLE_ASSIGNMENT']);
	Form_Data_onChange("9","PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_4",value,Temp_Data);
 	//handleLastDataUSER_ROLE_ASSIGNMENT(Temp_Data);
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
 }; 
  

const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_0_Change = (event, index) => {
  const value = event.target.value;
  const Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));  
  Temp_Data['2'][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_0"] = value;
  setUSER_ROLE_ASSIGNMENT(Temp_Data);
};


const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_1_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["2"][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_1"]=value;
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
	//handleAddUSER_ROLE_ASSIGNMENT(Temp_Data,App_Data['USER_ROLE_ASSIGNMENT']);
  }; 
  

const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_2_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["2"][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_2"]=value;
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
	//handleAddUSER_ROLE_ASSIGNMENT(Temp_Data,App_Data['USER_ROLE_ASSIGNMENT']);
  }; 
  

const PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_3_Change = (event,index) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
	Temp_Data["2"][index]["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_3"]=value;
    setUSER_ROLE_ASSIGNMENT(Temp_Data);
	//handleAddUSER_ROLE_ASSIGNMENT(Temp_Data,App_Data['USER_ROLE_ASSIGNMENT']);
  }; 
  



 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!USER_ROLE_ASSIGNMENT) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {
	  case('2'):
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_0']='';
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_1']='';
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_2']='';
	    newRow['PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_3']='';
	    break;

  }


  const updatedUSER_ROLE_ASSIGNMENT =JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
  updatedUSER_ROLE_ASSIGNMENT[Sec] = [...updatedUSER_ROLE_ASSIGNMENT[Sec], newRow];
  setUSER_ROLE_ASSIGNMENT(updatedUSER_ROLE_ASSIGNMENT);
};

const handleDeleteRow = (sec,index) => {
  const updatedUSER_ROLE_ASSIGNMENT = JSON.parse(JSON.stringify(USER_ROLE_ASSIGNMENT));
  updatedUSER_ROLE_ASSIGNMENT[sec].splice(index, 1);
  setUSER_ROLE_ASSIGNMENT(updatedUSER_ROLE_ASSIGNMENT);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`User Role Assignment`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`User Role ID`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`User Role ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_0" type="text" className="form-control" placeholder="User Role ID" value={USER_ROLE_ASSIGNMENT["1"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_0`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter User Role ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`User ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_1" type="text" className="form-control" placeholder="User ID" value={USER_ROLE_ASSIGNMENT["1"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_1`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter User ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Role ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_2" type="text" className="form-control" placeholder="Role ID" value={USER_ROLE_ASSIGNMENT["1"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_2`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Role ID`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         <div className="container-fluid mt-5">
            <h2  id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_HEADER">{t(`Scope Type`)} <span className="toggle-icon">^</span></h2>
            <div  id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_SECTION"  className="table">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('2')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table2" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`Scope Type`)}</th>
                        <th>{t(`Asset ID`)}</th>
                        <th>{t(`Offering ID`)}</th>
                        <th>{t(`Organization ID`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {USER_ROLE_ASSIGNMENT['2'].map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
                        <td  data-order={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_0`]} data-search={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_0`]}>
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
                                 <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_0"  onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_0_Change(ev, i)}  className="form-control" value={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_0`]} name="Scope Type">
						  <option value="Asset">Asset</option>
						  <option value="Offering">Offering</option>
						  <option value="Organization">Organization</option>
						  <option value="Platform">Platform</option>
						  <option value="Token Type">Token Type</option>

                                 </select>
                              </div>
                           </div>
                        </td>
                        <td  data-order={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_1`]} data-search={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_1`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_1" type="text" onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_1_Change(ev, i)} className="form-control" value={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_1`]} placeholder="Asset ID"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_2`]} data-search={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_2`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_2" type="text" onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_2_Change(ev, i)} className="form-control" value={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_2`]} placeholder="Offering ID"/>
							  </div>
                           </div>
                        </td>
                        <td  data-order={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_3`]} data-search={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_3`]} >
                           <div className="card" style={{ border: 'none'}}>
                              <div className="card-body">
								<input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_3" type="text" onChange={(ev) => PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_3_Change(ev, i)} className="form-control" value={e[`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_2_3`]} placeholder="Organization ID"/>
							  </div>
                           </div>
                        </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Effective From`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_SECTION" className="row">
			                {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Effective From`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_0" type="date"  value={USER_ROLE_ASSIGNMENT["3"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_0`]} 
							onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_0_Change} style={{ borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Effective From
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Effective To`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_1" type="date"  value={USER_ROLE_ASSIGNMENT["3"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_1`]} 
							onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_1_Change} style={{ borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_1"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Effective To
					  </div>
				  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_2" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Active`)} <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_2" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_2_Change} 
					  checked={USER_ROLE_ASSIGNMENT?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_2"] === "true" || USER_ROLE_ASSIGNMENT?.["3"]?.["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_3_2"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_0"  value={USER_ROLE_ASSIGNMENT["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_0`]} onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_1" type="text" className="form-control" placeholder="Created By" value={USER_ROLE_ASSIGNMENT["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_1`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_2" type="text" className="form-control" placeholder="Created At" value={USER_ROLE_ASSIGNMENT["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_2`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_3" type="text" className="form-control" placeholder="Updated By" value={USER_ROLE_ASSIGNMENT["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_3`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_4" type="text" className="form-control" placeholder="Updated At" value={USER_ROLE_ASSIGNMENT["9"][`PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_4`]} 
						onChange={PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_01_SYSTEM_ADMIN_PLATFORM_ADMIN_USER_ROLE_ASSIGNMENT_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default User_Role_Assignment;  